import { Component } from "@angular/core";
import { Platform, ToastController } from "@ionic/angular";
import { NavigationEnd, Router } from "@angular/router";
import { ServiceWorkerUpdateService } from "./core/services/service-worker-update.service";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Storage } from "@ionic/storage";
import { NetworkService } from "./services/network.service";
import { TokenControllerService } from "./messages-sdk/services/token-controller.service";
import { TranslateService } from "@ngx-translate/core";
import { CodebaseTranslateService } from "./services/codebase-translate.service";
import { ChannelsClientService } from "./messages-sdk/services/channels-client.service";
import { Push, PushObject, PushOptions } from "@ionic-native/push/ngx";
import { environment } from "@env/environment";
import { WeatherApiService } from "./shared/weather-api/weather-api.service";
import moment from "moment";
import { StorageService } from "./services/storage.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CMSDataControllerService } from "./core/data/controller/cmsdata-controller.service";
import { SocialWallClientService } from "./shared/social-wall-client/social-wall-client.service";
import { DistanceUtilsService } from "./shared/services/distance-utils.service";
import { SecureUserRepositoryService } from "./core/users-api/secure-user-repository.service";
import { SharedConstantsService } from "./shared/services/shared-constants.service";
import { BasePageComponent } from "./shared/base-page/base-page.component";
import { ContentAnalyticsService } from "./services/content-analytics.service";
import { AudienceAnalyticsService } from "./services/audience-analytics.service";
import { filter } from "rxjs/operators";
import firebase from 'firebase/app';


declare function require(name: string);

@Component({
  selector: "app-root",
  templateUrl: require("template/" +
    environment.template +
    "/html/app.component.html"),
})
export class AppComponent extends BasePageComponent {
  public showSplash: boolean = true;
  public splashImage: string;
  weather: any;
  public mainImage: any;
  currentRegion: any;
  public environment = environment;
  bodyStyles = document.body.style;
  deferredPrompt: any;
  regions: any;
  public IBURL :SafeResourceUrl;
  messaging: firebase.messaging.Messaging;
  private deferredPWAInstallPrompt: any = null;
  private androidPermissionRequested = false;
  private androidValidationInFlight = false;
  swConfigSignature: string;
  swControllerListenerAttached: any;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private update: ServiceWorkerUpdateService,
    private router: Router,
    private storage: Storage,
    protected contentAnalytics: ContentAnalyticsService,
    private push: Push,
    private toastController: ToastController,
    private tokenController: TokenControllerService,
    private networkService: NetworkService,
    private dataController: CMSDataControllerService,
    private distanceUtils: DistanceUtilsService,
    private translate: TranslateService,
    private userRepository: SecureUserRepositoryService,
    private sharedConstants: SharedConstantsService,
    private storageService: StorageService,
    private channelService: ChannelsClientService,
    private socialWallClient: SocialWallClientService,
    private weatherApiService: WeatherApiService,
    private audienceAnalytics: AudienceAnalyticsService,
    private codebaseTranslateService: CodebaseTranslateService,
    private sanitizer: DomSanitizer
  ) {
    super(contentAnalytics)
    this.initializeApp();
    // storage.get('language').then(lang => {
    // })
    // Solo inicializamos Firebase si no est� ya inicializado
    if (!firebase.apps.length) {
      firebase.initializeApp(environment.firebase);
    }

    if (!environment.production) return;
    // ? Verifica si el navegador soporta Firebase Messaging
    if (
      firebase.messaging.isSupported &&
      firebase.messaging.isSupported()
    ) {
      // ? Verifica que el navegador soporte SW
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/combined-sw.js')
          .then(registration => {

            this.messaging = firebase.messaging();
            this.messaging.useServiceWorker(registration);
            this.syncServiceWorkerConfig(registration);

            if (this.platform.is("android")){
              this.validateAndroidDeviceTokenOrRequestPermission();
            }
            this.listen();
          })
          .catch(err => {
            console.error('❌ Error al registrar Service Worker:', err);
          });
      } else {
        console.warn('❗ Este navegador no soporta Service Workers');
      }
    } else {
      console.warn('❗ Firebase Messaging no es compatible en este navegador');
    }
  }

listen() {
  this.messaging.onMessage(payload => {
    console.log('Foreground message:', payload);

    if (Notification.permission !== 'granted') {
      return;
    }

    const notif = payload && payload.notification ? payload.notification : null;
    if (!notif) {
      return;
    }

    const title = notif.title ? notif.title : 'Notification';

    new Notification(title, {
      body: notif.body ? notif.body : '',
      icon: notif.icon ? notif.icon : '/assets/icons/icon-192x192.png',
      data: payload && payload.data ? payload.data : {}
    });
  });
}

ngOnInit() {
    super.ngOnInit();
    this.storageService.watchItinerarySrc().subscribe((newValue) => {
      if (newValue) {
        if (!document.URL.includes('staging') || !document.URL.includes('localhost')){
          this.IBURL = this.sanitizer.bypassSecurityTrustResourceUrl(newValue); // Realiza la l�gica necesaria
        }else{
          newValue = newValue.replace('-qa', '');
          this.IBURL = this.sanitizer.bypassSecurityTrustResourceUrl(newValue); // Realiza la l�gica necesaria

        }
      }
    });

    this.setupPWAInstallPromptListener();

    if (environment.regions.enabled){
      this.detectUserRegion();
    }else{
      this.storage.remove("activeRegion");
    }
    // Track content view
    this.contentAnalytics.trackContentView(
      'App',
      environment.theme.name,
      environment.theme.appCode
    );

  }

  async initializeApp() {
    // Track session start
    this.audienceAnalytics.trackSessionStart();
    // Set up automatic page tracking
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const pageName = this.getPageName(event.urlAfterRedirects);
      const pageClass = this.getPageClass(event.urlAfterRedirects);

      this.audienceAnalytics.trackScreenView(pageName, pageClass);
    });

    this.IBURL = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.ItineraryBuilder.base_url}`);
    this.showSplash = environment.showSplash;
    if (this.showSplash) {
      this.weatherApiService
        .getWeather({ zipCode: environment.cms.postalCode })
        .then((weather) => {
          // this.weather = {
          //   icon: this.getIconWeather(weather.Forecast.Today.Description),
          //   current: `${weather.Forecast.Today.Current}�`,
          //   date: moment().format('dddd, MMMM D, YYYY')
          // }

          // this.codebaseTranslateService.languageChange("eng");
          var timer = 0;
          var interval = setInterval(() => {
            timer++;
            if (timer < 7) {
            } else {
              clearInterval(interval);
              this.showSplash = false;
              //console.log('Done');
            }
          }, 1000);
        })
        .catch((err) => {
          console.error(err);
          this.weather = ".";

          // this.codebaseTranslateService.languageChange("eng");
          var timer = 0;
          var interval = setInterval(() => {
            timer++;
            if (timer < 7) {
            } else {
              clearInterval(interval);
              this.showSplash = false;
              //console.log('Done');
            }
          }, 1000);
        });
      this.mainImage = `/themes/${environment.theme.name}/assets/splash/background-splash.png`;
      this.bodyStyles.setProperty(
        "--image",
        `url("/themes/${environment.theme.name}/assets/splash/background-splash.png")`
      );
      this.bodyStyles.setProperty(
        "--logo",
        `url("/themes/${environment.theme.name}/assets/login/logo.png")`
      );
      this.splashImage = `../../../themes/${environment.theme.name}/assets/login/logIn_background.png`;
    }
    // this.codebaseTranslateService.languageChange('eng')
    // this.codebaseTranslateService.initLanguage();
    if (this.networkService.getCurrentNetworkStatus() < 1) {
      const toast = await this.toastController.create({
        message: "This app is offline",
        duration: 2000,
        buttons: [
          {
            text: "Close",
            handler: () => {},
          },
        ],
      });
      toast.present();
    }

    // Ensure lastLocation state (clear if no permission) before using it
    try { await this.distanceUtils.getCurrentLocation(); } catch {}
    const lastLocation = await this.storage.get("lastLocation");
    let promises = [];
    if (!environment.noData) {
      promises.push(this.dataController.getListings2({
        domainId: environment.cms.domainId,
        dataSyndication: false,
        latitude: lastLocation ? lastLocation.latitude : environment.cms.main_coordinates.latitude,
        longitude: lastLocation ? lastLocation.longitude : environment.cms.main_coordinates.longitude,
      }).toPromise());
      if (environment.hasEventsData){
        promises.push(this.dataController.getEventsByWeek({
          domainId: environment.cms.domainId,
          dataSyndication: false,
          latitude: lastLocation ? lastLocation.latitude : environment.cms.main_coordinates.latitude,
          longitude: lastLocation ? lastLocation.longitude : environment.cms.main_coordinates.longitude,
          daysCount: 28,
          firstDayOfWeek: 0
        }).toPromise());
      }

      if (environment.regions.enabled){
        promises.push(this.dataController.getPageById({pageId: environment.regions.regionsPageId}).toPromise())
      }
    }

    if (environment.hasSocialWall){
      promises.push(this.socialWallClient.getMedias({client_secret: environment.socialWall.client_secret, client_id: environment.socialWall.client_id}, 0, 50));
    }

    Promise.all(promises).then(resp => {
      if (!environment.noData) {
        this.storage.set("listings", resp[0]);
        if (environment.hasEventsData){
          this.storage.set("events", resp[2]);
        }
        if (environment.regions.enabled){
          this.regions = resp[3]
          this.storage.set("regions", resp[3])
        }
      }
      if (environment.hasSocialWall){
        this.storage.set("medias", resp[1].Medias);
      }
    })
    // })

    const isIOS = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
    const isStandalone = ('standalone' in window.navigator) && (window.navigator['standalone'] === true);
    if (this.platform.is("android")) {
      this.validateAndroidDeviceTokenOrRequestPermission();
    } else if (isIOS && isStandalone) {
      this.requestPushPermission();
    }
  }

  private async validateAndroidDeviceTokenOrRequestPermission(): Promise<void> {
    if (this.androidPermissionRequested || this.androidValidationInFlight) {
      return;
    }

    this.androidValidationInFlight = true;
    const permissionAllowed = await this.storage.get('notificationAllowed');
    let shouldRequestPermission = !permissionAllowed;

    try {
      let storedToken = await this.storage.get('tokenDevice');
      if (!storedToken) {
        storedToken = await this.storage.get('apnsToken');
        if (storedToken) {
          await this.storage.set('tokenDevice', storedToken);
        }
      }

      const tokenForValidation = this.resolveTokenForValidation(storedToken);

      if (tokenForValidation) {
        const response = await this.tokenController.validateDeviceToken(tokenForValidation);
        if (this.isDeviceValidationSuccessful(response)) {
          shouldRequestPermission = false;
        } else if (permissionAllowed) {
          // Permission already granted; refresh the token without re-prompting the user
          this.requestPermission();
          shouldRequestPermission = false;
        } else {
          shouldRequestPermission = true;
        }
      } else if (!permissionAllowed) {
        shouldRequestPermission = true;
      }
    } catch (error) {
      // console.log('dY"" Android device validation failed:', error);
      if (!permissionAllowed) {
        shouldRequestPermission = true;
      }
    } finally {
      this.androidValidationInFlight = false;
    }

    if (shouldRequestPermission && !this.androidPermissionRequested) {
      this.androidPermissionRequested = true;
      this.requestPermission();
    }
  }

  private isDeviceValidationSuccessful(response: any): boolean {
    if (response === null || response === undefined) {
      return false;
    }

    if (typeof response === 'boolean') {
      return response;
    }

    if (typeof response === 'object') {
      if ('isValid' in response) {
        return !!response.isValid;
      }
      if ('valid' in response) {
        return !!response.valid;
      }
    }

    return true;
  }

  private resolveTokenForValidation(storedToken: any): string | null {
    if (!storedToken) {
      return null;
    }

    if (typeof storedToken === 'string') {
      const trimmed = storedToken.trim();
      if (!trimmed) {
        return null;
      }
      try {
        const parsed = JSON.parse(trimmed);
        if (parsed && typeof parsed === 'object' && typeof parsed.endpoint === 'string') {
          return parsed.endpoint;
        }
      } catch {
        return trimmed;
      }
      return trimmed;
    }

    if (typeof storedToken === 'object' && typeof storedToken.endpoint === 'string') {
      return storedToken.endpoint;
    }

    return null;
  }

async requestPushPermission() {

  const registration = await navigator.serviceWorker.ready;
  console.log('registration', registration)
  // Verifica si ya est� suscrito
  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) {
    console.log('? Ya suscrito:', existingSubscription);
    await this.storage.set("tokenDevice", JSON.stringify(existingSubscription));
    await this.storage.set("iosSubscribed", true);
    // Puedes enviarlo nuevamente a tu backend si lo necesitas
    return existingSubscription;
  }

  if (!('Notification' in window)) {
      await this.storage.set("iosSubscribed", false);
    console.warn('? Este navegador no soporta notificaciones.');
    return;
  }

  if (Notification.permission === 'granted') {
      await this.storage.set("iosSubscribed", true);
    console.log('? Permiso ya concedido');
    return;
  }

  if (Notification.permission === 'denied') {
      await this.storage.set("iosSubscribed", false);
    console.warn('?? Permiso denegado anteriormente');
    return;
  }

  const result = await Notification.requestPermission();
  console.log('?? Resultado del permiso:', result);
}

  async subscribeToPushNotifications() {
    if (!('serviceWorker' in navigator)) {
      console.warn('? Service Workers no soportados');
      return;
    }

    if (!('PushManager' in window)) {
      console.warn('? PushManager no soportado');
      return;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('?? Permiso denegado para notificaciones');
      return;
    }

    const registration = await navigator.serviceWorker.ready;

    // Verifica si ya est� suscrito
    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      // Puedes enviarlo nuevamente a tu backend si lo necesitas
      return existingSubscription;
    }

    // Suscribirse por primera vez
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.urlBase64ToUint8Array(environment.messagesSDK.VAPID_PUBLIC_KEY),
    });


    // ?? Aqu� deber�as enviar el objeto `subscription` a tu backend
    return subscription;
  }

  urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }

  private getPageName(url: string): string {
    // Extract page name from URL
    const segments = url.split('/').filter(segment => segment);
    return segments.length > 0 ? segments[segments.length - 1] : 'home';
  }

  private getPageClass(url: string): string {
    // Map URL to a page class
    if (url.includes('/trails')) {
      return 'TrailsPage';
    } else if (url.includes('/events')) {
      return 'EventsPage';
    } else if (url.includes('/home')) {
      return 'HomePage';
    } else if (url.includes('/more')) {
      return 'MorePage';
    } else if (url.includes('/listings')) {
      return 'ListingsPage';
    } else if (url.includes('/connect-with-us')) {
      return 'ConnectWithUsPage';
    } else if (url.includes('/help')) {
      return 'HelpPage';
    } else if (url.includes('/me-tnt')) {
      return 'ProfilePage';
    } else if (url.includes('/login')) {
      return 'LoginPage';
    } else if (url.includes('/sign-up')) {
      return 'SignUpPage';
    } else if (url.includes('/category')) {
      return 'CategoryPage';
    } else if (url.includes('/deals')) {
      return 'DealsPage';
    } else if (url.includes('/digital-brochure')) {
      return 'BrochurePage';
    } else if (url.includes('/scavenger-hunts')) {
      return 'ScavengerHuntsPage';
    } else if (url.includes('/social-wall')) {
      return 'SocialWallPage';
    } else if (url.includes('/inbox')) {
      return 'InboxPage';
    }
    // Add other mappings
    return 'AppPage';
  }
  getIconWeather(state: string): string {
    switch (state.toLowerCase()) {
        case 'clear':
        case 'sunny':
            return '☀️';
        case 'night clear':
            return '🌙';
        case 'partly cloudy':
        case 'scattered clouds':
            return '🌤️';
        case 'clouds':
        case 'broken clouds':
        case 'few clouds':
          return '☁️';
        case 'overcast':
        case 'overcast clouds':
            return '🌥️';
        case 'rain':
        case 'shower rain':
        case 'light rain':
            return '🌧️';
        case 'heavy rain':
            return '🌧️';
        case 'storm':
        case 'thunderstorm':
        case 'light thunderstorm':
        case 'heavy thunderstorm':
        case 'thunderstorm with rain':
            return '⛈️';
        case 'drizzle':
        case 'light drizzle':
            return '🌦️';
        case 'snow':
        case 'light snow':
        case 'heavy snow':
            return '❄️';
        case 'sleet':
            return '🌨️';
        case 'mist':
        case 'haze':
            return '🌫️';
        case 'wind':
        case 'breeze':
        case 'strong breeze':
        case 'gale':
        case 'strong gale':
            return '🌬️';
        case 'fog':
            return '🌁';
        case 'smoke':
            return '🔥';
        case 'sand':
        case 'dust':
            return '🌪️';
        case 'tornado':
            return '🌪️';
        case 'hurricane':
        case 'cyclone':
        case 'typhoon':
            return '🌀';
        case 'cold':
            return '🥶';
        case 'hot':
            return '🥵';
        default:
            return '🌤️';
    }
}

async detectUserRegion() {
  try {
    const userLocation = await this.distanceUtils.getCurrentLocation();

    if (!userLocation) {
      const userZipCode = await this.userRepository.getAdditionalField(this.sharedConstants.apZipCode);

      try {
        const weather = await this.weatherApiService.getWeather({ zipCode: userZipCode });

        let region = await this.distanceUtils.findMatchingRegion(weather.Forecast.City);
        await this.storage.set("suggestedRegion", region);
        return region;
      } catch (err) {
        await this.storage.set("suggestedRegion", this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion));
        return this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion);
      }
    }

    const nearestRegion = this.distanceUtils.findNearestRegion(userLocation);
    await this.storage.set("suggestedRegion", nearestRegion);

    return nearestRegion;
  } catch (error) {
    console.error("Error obtaining user location:", error);
    await this.storage.set("suggestedRegion", this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion));
    return this.distanceUtils.findMatchingRegion(environment.regions.defaultRegion);
  }
}

  private syncServiceWorkerConfig(registration?: ServiceWorkerRegistration): void {
    if (!("serviceWorker" in navigator)) {
      return;
    }

    const payload = this.buildServiceWorkerPayload();
    if (!payload) {
      return;
    }

    const signature = JSON.stringify(payload);
    this.swConfigSignature = signature;

    const message = { type: "SET_SW_CONFIG", payload };
    const postMessage = (worker?: ServiceWorker | null) => {
      if (!worker) {
        return;
      }

      try {
        worker.postMessage(message);
      } catch (err) {
        console.error("[AppComponent] Unable to sync service worker config", err);
      }
    };

    if (registration) {
      postMessage(registration.active);
      postMessage(registration.waiting);

      const installingWorker = registration.installing;
      if (installingWorker) {
        installingWorker.addEventListener("statechange", () => {
          if (installingWorker.state === "activated") {
            postMessage(installingWorker);
          }
        });
      }
    }

    navigator.serviceWorker.ready
      .then(reg => postMessage(reg.active))
      .catch(err => console.error("[AppComponent] Unable to access active service worker", err));

    if (!this.swControllerListenerAttached) {
      this.swControllerListenerAttached = true;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        navigator.serviceWorker.ready
          .then(reg => postMessage(reg.active))
          .catch(err => console.error("[AppComponent] Unable to access active service worker", err));
      });
    }
  }

  private buildServiceWorkerPayload(): any {
    const firebaseConfig = environment.firebase;
    if (!firebaseConfig) {
      return null;
    }

    const theme = environment.theme && environment.theme.name ? environment.theme.name : null;
    const versionSource: any = (environment as any).versionNumber;
    const rawVersion = typeof versionSource === "string" ? versionSource.trim() : "";
    const sanitizedVersion = rawVersion.replace(/[^0-9a-z]/gi, "").toLowerCase();
    const cacheVersion = sanitizedVersion.length > 0 ? sanitizedVersion : "1";
    const versionTag = "v" + cacheVersion;
    const themeSlug = theme
      ? theme.toLowerCase().replace(/[^0-9a-z]+/g, "-").replace(/^-+|-+$/g, "") || "theme"
      : "pwa";
    const payload: any = {
      firebase: firebaseConfig,
      currentDomain: window.location.origin,
      cacheName: `${themeSlug}-pwa-${cacheVersion}`,
      cacheVersion,
      staticCacheName: `${cacheVersion}_pwa-static`,
      dynamicCacheName: `${cacheVersion}_pwa-dynamic`,
      version: versionTag
    };

    if (theme) {
      payload.themeName = theme;
      payload.iconPath = `/themes/${theme}/assets/icons/icon-512x512.png`;
    } else {
      payload.iconPath = "assets/icon/icon-512x512.png";
    }

    return payload;
  }

  requestNotificationPermission() {
    const options: PushOptions = {
      android: {},
      ios: {
        alert: "true",
        badge: true,
        sound: "false",
      },
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on("registration").subscribe(async (registration: any) => {
      // console.log("Device registered", registration);
      await this.storage.set("pushToken", registration);
      await this.tokenController.registerIosDeviceToken(registration);
      await this.channelService.postSubscribeToChannels(
        ["GlobalNotifications"],
        registration
      );
      // Aqu� puedes enviar el token de registro a tu servidor para enviar notificaciones.
    });

    pushObject.on("notification").subscribe((notification: any) => {
      // console.log("Received a notification", notification);
      // Aqu� puedes manejar la notificaci�n cuando se recibe.
    });

    pushObject.on("error").subscribe((error: any) => {
      console.error("Error with Push plugin", error);
    });
  }

  requestPermission() {
    const subscription = this.tokenController.requestPermission().subscribe(
      async token => {
        try {
          this.androidPermissionRequested = true;
          await this.storage.set('notificationAllowed', true);
          await this.storage.set("tokenDevice", token);
          await this.tokenController.registerDeviceToken(token);
          //console.log(token)
        } catch (registrationError) {
          // console.log('dY"" Error registering Android notification token:', registrationError);
        } finally {
          subscription.unsubscribe();
        }
      },
      async (err) => {
        await this.storage.set('notificationAllowed', false);
        this.androidPermissionRequested = false;
        // console.log('dY"" Error requesting Android notification permission:', err);
        subscription.unsubscribe();
      }
    );
  }




  // PWA install prompt handling
  private setupPWAInstallPromptListener() {
    // Listen unconditionally; older TS libs may not know this event type.
    (window as any).addEventListener('beforeinstallprompt', (event: any) => {
      // Prevent Chrome from showing the mini-infobar
      event.preventDefault();
      this.deferredPWAInstallPrompt = event;
      // Offer a custom UI to install
      this.showInstallToast();
    });

    (window as any).addEventListener('appinstalled', () => {
      this.deferredPWAInstallPrompt = null;
    });
  }

   private async showInstallToast() {
    try {
      const toast = await this.toastController.create({
        message: 'Install '+  environment.theme.appName +' to your Home Screen',
        position: 'bottom',
        buttons: [
          {
            text: 'Install',
            handler: () => {
              this.triggerPWAInstall();
            }
          },
          {
            text: 'Later',
            role: 'cancel'
          }
        ],
        duration: 0
      });
      await toast.present();
    } catch {}
  }

  private async triggerPWAInstall() {
    if (!this.deferredPWAInstallPrompt) return;
    try {
      this.deferredPWAInstallPrompt.prompt();
      await this.deferredPWAInstallPrompt.userChoice;
    } catch {}
    this.deferredPWAInstallPrompt = null;
  }
}




